import { TemaPageDto } from '@jobindsats/typescript-fetch-jobindsats';
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { MalingOmraadeService } from './services/maling-omraade-api-service';
import { getDisplayNameFromPeriodType } from '../util/period-type-parser';

@customElement('maaling-omraade-data-element')
export class MaalingOmraadeDataElement extends JobindsatsElement(LitElement) {

    static styles = css`
        .glyphicon {
            top: 4px;
        }
        a:hover circle{
            fill: var(--link-hover);
            stroke: var(--link-hover);
        }
        `;

    @property({
        attribute: 'maaling-name'
    })
    maalingName?: string;

    @property({
        attribute: 'maaling-id'
    })
    maalingId?: string;

    @property({
        attribute: 'maaling-url'
    })
    maalingUrl?: string;

    @property({
        attribute: 'maaling-info-url'
    })
    maalingInfoUrl?: string;

    maalingService: MalingOmraadeService;

    @state()
    metadataMaaling?: TemaPageDto;

    constructor() {
        super();
        this.maalingService = new MalingOmraadeService();
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.maalingId) {
            this.maalingService.getMetadataMaalingValues({ maalingId: this.maalingId }).then(res => 
                this.metadataMaaling = res);
        }
    }


    render() {
        if (this.metadataMaaling) {
            return html
                `   <maaling-accordion-element title="${this.maalingName ? this.maalingName : ''}" heading-level="2" .updateInfo=${this.metadataMaaling.updateInfo} maaling-url="${this.maalingUrl ? this.maalingUrl : ''}">
                        <p><strong>Første og seneste periode:</strong> ${this.metadataMaaling.period?.firstAndLast ? this.metadataMaaling.period?.firstAndLast.join(' - ') : ''}</p>
                        <p><strong>Opdateringsfrekvens:</strong> ${this.metadataMaaling.updateFreq}</p>
                        <br>
                        <p><strong>Målingsvariable:</strong> ${this.metadataMaaling.mGroups ? this.metadataMaaling.mGroups.join(', ') : ''} </p>
                        <p><strong>Område:</strong> ${this.metadataMaaling.area?.wholeCountry ? 'Hele landet, ' : ''} ${this.metadataMaaling.area && this.metadataMaaling.area.areas ? this.metadataMaaling.area.areas.join(', ') : ''}</p>
                        <p><strong>Periode:</strong> ${this.metadataMaaling.period?.types ? [...this.metadataMaaling.period?.types].map(period => getDisplayNameFromPeriodType(period)).join(', ') : ''} </p>
                        <p><strong>Fordelingsvariable:</strong> ${this.metadataMaaling.dimensions ? this.metadataMaaling.dimensions.join(', ') : ''}</p>
                        <br>
                        <a href="${this.maalingInfoUrl ? this.maalingInfoUrl : ''}" target="_blank">
                            <span class="icon glyphicon">
                                <svg width="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="6" cy="6" r="5.5" fill="#003087" stroke="#003087"/>
                                    <path d="M5.50103 4.46H6.49303V8.5H5.50103V4.46ZM6.54903 2.628V3.612H5.43703V2.628H6.54903Z" fill="white"/>
                                </svg>
                            </span>Gå til info</a>
                    </maaling-accordion-element>`;
        }}
    


}